module.exports = __webpack_public_path__ + "img/Осенние дожди. х-м 60х90. 2002г. 800$.5baeeaae.jpg";